import * as config from '@/config.json'

import Loading from 'vue-loading-overlay'
import axios from 'axios'

export default {
  name: 'ManagerUserPermissions',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      token: null,
      userId: null,
      userName: '',
      allPermissionsMobile: [],
      allPermissionsWeb: [],
      values: [],
      page: '',
      isBusy: false,
      tabIndex: 0,
      search: '',
      currentPage: 1,
      pageSize: 10,
      selectedCategory: null,
      optionsCategory: [],
      isActiveAll: false
    }
  },

  methods: {
    isNewCategoryWeb(index) {
      if (index === 0) return true
      return this.allPermissionsWeb[index].category !== this.allPermissionsWeb[index - 1].category
    },

    isNewCategoryMobile(index) {
      if (index === 0) return true
      return this.allPermissionsMobile[index].category !== this.allPermissionsMobile[index - 1].category
    },

    redirect() {
      const ref = localStorage.getItem('redirectUserPermissions') ? localStorage.getItem('redirectUserPermissions') : 'users-list'
      localStorage.removeItem('redirectUserPermissions')
      this.$router.push(ref)
    },

    async readParamsUserPermission() {
      this.userId = this.$route.params.userId
      this.userName = this.$route.params.userName
      this.page = this.$route.params.page
    },

    buildDataUserPermissionsRequest(userId, description, categoryId, page, pageSize) {
      const data = {
        userId: userId,
        description: description,
        page: page,
        pageSize: pageSize
      }

      if (categoryId) {
        data.categoryId = categoryId
      }

      return data
    },

    async getAllPermissions(page) {
      this.isLoading = true

      const url = `${config.default.urlBase}/users/permissions/search/grouped`
      const data = this.buildDataUserPermissionsRequest(this.userId, this.search, parseInt(this.selectedCategory), page, this.pageSize)

      try {
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          // Garantir que sempre sejam arrays, mesmo quando a API retorna undefined
          this.allPermissionsMobile = response.data.items.mobile || []
          this.allPermissionsWeb = response.data.items.web || []

          if (this.allPermissionsMobile && this.allPermissionsMobile.length > 0) {
            this.tabIndex = 0
          } else if (this.allPermissionsWeb && this.allPermissionsWeb.length > 0) {
            this.tabIndex = 1
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        // Garantir que sempre sejam arrays vazios em caso de erro
        this.allPermissionsMobile = []
        this.allPermissionsWeb = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getAllPermissionsWithoutFilters() {
      const url = `${config.default.urlBase}/users/permissions/search/grouped`
      const data = this.buildDataUserPermissionsRequest(this.userId, '', null, 1, 1000) // Sem filtros, página grande

      try {
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          return {
            mobile: response.data.items.mobile || [],
            web: response.data.items.web || []
          }
        }

        // Se não for 200, retornar arrays vazios
        return {
          mobile: [],
          web: []
        }
      } catch (error) {
        console.error('Erro ao buscar todas as permissões:', error)
        // Em caso de erro, retornar arrays vazios em vez de lançar exceção
        return {
          mobile: [],
          web: []
        }
      }
    },

    async buildDataUserPermissions() {
      // Buscar todas as permissões sem filtros para preservar o estado completo
      const allPermissions = await this.getAllPermissionsWithoutFilters()

      // Verificar se os dados são válidos
      if (!allPermissions || !allPermissions.mobile || !allPermissions.web) {
        console.error('Dados de permissões inválidos:', allPermissions)
        throw new Error('Não foi possível obter as permissões do usuário')
      }

      console.log('Todas as permissões (sem filtros):', allPermissions)
      console.log('Permissões visíveis (com filtros):', {
        mobile: this.allPermissionsMobile,
        web: this.allPermissionsWeb
      })

      // Criar um mapa das permissões visíveis (com filtros) para facilitar a busca
      const visiblePermissionsMap = new Map()

      // Garantir que sejam arrays mesmo quando a API retorna undefined
      const visibleMobile = this.allPermissionsMobile || []
      const visibleWeb = this.allPermissionsWeb || []

      console.log('Arrays de permissões visíveis:', {
        visibleMobile: visibleMobile,
        visibleWeb: visibleWeb,
        allPermissionsMobile: this.allPermissionsMobile,
        allPermissionsWeb: this.allPermissionsWeb
      })

      visibleMobile.forEach(permission => {
        visiblePermissionsMap.set(permission.userPermissionId, permission.isActive)
      })

      visibleWeb.forEach(permission => {
        visiblePermissionsMap.set(permission.userPermissionId, permission.isActive)
      })

      // Processar permissões mobile
      const permissionsActiveMobile = allPermissions.mobile
        .map(permission => {
          // Se a permissão está visível (com filtros), usar o estado atual
          // Se não está visível, manter o estado original
          const isVisible = visiblePermissionsMap.has(permission.userPermissionId)
          return {
            ...permission,
            isActive: isVisible ? visiblePermissionsMap.get(permission.userPermissionId) : permission.isActive
          }
        })
        .filter(permission => permission.isActive)

      // Processar permissões web
      const permissionsActiveWeb = allPermissions.web
        .map(permission => {
          // Se a permissão está visível (com filtros), usar o estado atual
          // Se não está visível, manter o estado original
          const isVisible = visiblePermissionsMap.has(permission.userPermissionId)
          return {
            ...permission,
            isActive: isVisible ? visiblePermissionsMap.get(permission.userPermissionId) : permission.isActive
          }
        })
        .filter(permission => permission.isActive)

      const permissions = []
      permissions.push(...permissionsActiveMobile.map(permission => permission.userPermissionId))
      permissions.push(...permissionsActiveWeb.map(permission => permission.userPermissionId))

      console.log('Permissões ativas finais:', {
        mobile: permissionsActiveMobile.length,
        web: permissionsActiveWeb.length,
        total: permissions.length
      })

      return {
        userId: this.userId,
        permissions: permissions
      }
    },

    async createOrUpdate() {
      this.isBusy = true
      const url = `${config.default.urlBase}/users/permissions`

      try {
        const data = await this.buildDataUserPermissions()

        console.log({
          data
        })

        const response = await axios({
          url,
          method: 'put',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status === 200) {
          // Permissões atualizadas com sucesso (sem mostrar mensagem para evitar spam)
        }
      } catch (error) {
        console.log({
          error
        })

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao criar ou atualizar as permissões! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      } finally {
        this.isBusy = false
      }
    },

    async getAllCategories() {
      try {
        const url = `${config.default.urlBase}/users/permissions/categories`

        const response = await axios({
          method: 'GET',
          url,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })

        if (response.status === 200) {
          this.isLoading = false
          this.optionsCategory = response.data.map(category => ({
            value: category.id,
            text: category.description
          }))
        }
      } catch (error) {
        console.error(error)
        this.isLoading = false
        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Erro', 'error')
          this.$router.push('login')
        } else {
          await this.$alert(`Erro ao buscar categorias! Erro: ${error.response.data.message}`, 'Erro', 'error')
        }
        this.selectedCategory = null
      }
    },

    async goBackAndLogout() {
      const loggedUserId = sessionStorage.getItem('idUsuarioLogado')
      const isSameUser = String(this.userId) === String(loggedUserId)

      if (isSameUser) {
        // Usuário editando as próprias permissões: manter pergunta para desconectar
        const res = await this.$swal({
          title: 'Aplicar Permissões',
          text: 'Deseja desconectar da plataforma para aplicar as permissões? Se não desconectar, as permissões serão aplicadas somente no próximo login.',
          icon: 'question',
          showCancelButton: true,
          reverseButtons: false,
          confirmButtonColor: '#fe5c3a',
          cancelButtonColor: '#303030',
          confirmButtonText: 'Não, continuar',
          cancelButtonText: 'Sim, desconectar'
        })

        if (res.isConfirmed) {
          this.redirect()
        } else {
          this.$router.push('login')
        }
      } else {
        await this.$swal({
          title: 'Permissões atualizadas',
          text: `Para aplicar as permissões do usuário ${this.userName}, será necessário fazer o login novamente.`,
          icon: 'info',
          confirmButtonColor: '#fe5c3a',
          confirmButtonText: 'Entendi'
        })
        this.redirect()
      }
    },

    async activeAll(item) {
      item.forEach(async element => {
        element.isActive = true
      })

      await this.createOrUpdate()
    },

    async inactiveAll(item) {
      item.forEach(async element => {
        element.isActive = false
      })

      await this.createOrUpdate()
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')
    await this.readParamsUserPermission()

    await this.getAllPermissions(this.currentPage)

    await this.getAllCategories()
    this.isLoading = false
  },

  computed: {
    permissionsWeb() {
      if (this.allPermissionsWeb) {
        return [...this.allPermissionsWeb].sort((a, b) => {
          const catA = a.category || ''
          const catB = b.category || ''

          return catA.localeCompare(catB)
        })
      }
    },

    permissionsMobile() {
      if (this.allPermissionsMobile) {
        return [...this.allPermissionsMobile].sort((a, b) => {
          const catA = a.category || ''
          const catB = b.category || ''

          return catA.localeCompare(catB)
        })
      }
    }
  }
}
